import React, { useState } from "react";
import { MessageSquarePlus } from "lucide-react";
import FeedbackModal from "./FeedbackModal";

/**
 * Floating action button — always visible in the dashboard.
 * Positioned bottom-right; opens the feedback modal.
 */
export default function FeedbackButton() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                aria-label="Geef feedback"
                title="Geef feedback (B)"
                data-testid="feedback-fab"
                className="jr-feedback-fab group fixed bottom-20 right-6 z-40 inline-flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-[var(--jr-brand)] text-white shadow-[0_10px_30px_-10px_rgba(0,0,0,0.6),0_0_0_1px_rgba(255,255,255,0.06)] hover:bg-[var(--jr-brand-2)] transition-all hover:translate-y-[-1px]"
            >
                <span className="relative grid place-items-center">
                    <span aria-hidden className="absolute -inset-1 rounded-full bg-white/30 opacity-0 group-hover:opacity-100 blur-sm transition-opacity" />
                    <MessageSquarePlus size={16} className="relative" />
                </span>
                <span className="text-sm font-medium tracking-tight">Feedback</span>
            </button>

            <FeedbackModal open={open} onClose={() => setOpen(false)} />
        </>
    );
}
